export default {"src":"/_next/static/media/important-places-blank.20e0d9a8.svg","height":149,"width":369,"blurWidth":0,"blurHeight":0};